import { IconButton, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { InitialNameAvatar } from "../../../../components/images/initial-name-avatar";
import { SimpleTable } from "../../../../components/mui/table";
import { RENDERER_TYPES } from "../../../../enums";
import {
  convertToFullName,
  convertToUrl,
  getConvertedExternalUrl,
} from "../../../../services/utils";
import { ROUTE_PATHS } from "../../../../routes/route-paths";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
function AmbassadorRequestListTable({
  list,
  columns,
  onRowSelect,
  selectedRows,
  onApproveClick,
  onRejectClick,
}: any) {
  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.CLICKABLE_FULL_NAME_WITH_AVATAR:
        return (
          <Link
            to={convertToUrl(ROUTE_PATHS.AMBASSADORS.DETAILS, {
              ":id": row?.ambassador?.id,
              ":tab": "info",
            })}
            style={{textDecoration: "none"}}
          >
            <InitialNameAvatar
              text={convertToFullName(row?.ambassador?.firstName, row?.ambassador?.lastName)}
              name={row?.ambassador?.firstName}
              image
              src={row?.ambassador?.picture}
            />
          </Link>
        );
      case RENDERER_TYPES.LINKEDIN_URL_WITH_ICON:
        return (
          <Link
            to={{ pathname: getConvertedExternalUrl(row?.ambassador?.[column.field]) }}
            target="_blank"
            title="Linkedin URL"
          >
            <LinkedInIcon />
          </Link>
        );
      case RENDERER_TYPES.ACTION:
        return (
          <Stack gap={1} direction="row">
            <IconButton
              aria-owns="ambassador-request-list-action-items"
              aria-haspopup="true"
              key={row.id}
              sx={{ p: 0 }}
              title="Approve"
              onClick={() => onApproveClick(row.id)}
            >
              <CheckCircleIcon sx={{ color: "green" }} />
            </IconButton>
            <IconButton
              aria-owns="ambassador-request-list-action-items"
              aria-haspopup="true"
              key={row.id}
              sx={{ p: 0 }}
              title="Reject"
              onClick={() => onRejectClick(row.id)}
            >
              <CancelIcon sx={{ color: "red" }} />
            </IconButton>
          </Stack>
        );
      default:
        break;
    }
  };

  return (
    <>
      <SimpleTable
        tdRenderer={handleTDRenderer}
        rows={list?.data}
        columns={columns}
        total={list?.total}
        fetching={list?.loading}
        onRowSelect={onRowSelect}
        selectedRows={selectedRows}
        showPagination={false}
      />
    </>
  );
}

export { AmbassadorRequestListTable };
